// Whether a failed auth request never reached Cognito: no network, or a raw fetch
// failure. Such a failure reveals nothing about an account, so the reset screens
// say so and let the user retry, where a Cognito response would get the screen's
// own handling. Cognito exceptions carry specific names (UserNotFoundException,
// CodeMismatchException, ...), so none of them match here.
export function isTransportError(err) {
  return (
    err?.name === 'NetworkError' ||
    err?.name === 'TypeError' || // a raw fetch failure ("Failed to fetch")
    (typeof navigator !== 'undefined' && navigator.onLine === false)
  );
}

export const TRANSPORT_ERROR_MESSAGE =
  "We couldn't reach Halo. Check your connection and try again.";
